<template>
  <div class="tree-content">
    <div>
      <el-row class="tree-header">
        <el-col :span="12" class="tree-header-title">
          部门
        </el-col>
        <el-col :span="12" style="text-align: right">
          <a style="cursor: pointer;" @click="openEditOrg(null)" v-if="$permission('org:add')">
            <!-- <i class="el-icon-plus add-styl"></i> -->
            <gj-button type="iconfont" iconfont="iconzengjia" size="20"></gj-button>
          </a>
        </el-col>
      </el-row>
    </div>
    <div class="top-input">
      <gj-button
          type="icon"
          plain
          style="font-size: 18px; min-width: 32px; margin-right: 5px;"
          @click="queryData"
      ><gj-icon iconfont="iconicon_home"></gj-icon></gj-button>

      <gj-input
          ref="filterInput"
          width="100%"
          v-model="filterText"
          placeholder="请输入部门名称"
      >
      </gj-input>
    </div>
    <div class="tree-body" v-loading="loading">
      <el-tree
          class="filter-tree"
          :data="data2"
          :props="defaultProps"
          highlight-current
          default-expand-all
          :expand-on-click-node="false"
          :filter-node-method="filterNode"
          @node-click="checkOrg"
          ref="tree2">
          <div class="custom-tree-node flex justify-between align-center" slot-scope="{ node, data }">
<!--            <div style="font-size: 12px">-->
              <div class="custom-tree-node-name" :style="{'max-width': 130-(node.level-1)*18 +'px' }"><!--{{data.id}}-->
                <gj-tooltip :text-line="1" :content="node.label" style="width: 100%;word-wrap: break-word;">
                  {{ node.label }}
                </gj-tooltip>
              </div>
              <div class="gj-tree-child">
                <gj-button
                    font14
                    type="text"
                    size="mini"
                    style="color: #333; padding: 0;"
                    @click.stop="openEditOrg(data)"
                    v-if="$permission('org:update')"
                >
                  <i class="el-icon-edit"></i>
                </gj-button>
                <gj-button
                    font14
                    type="text"
                    size="mini"
                    style="color: #333; padding: 0;"
                    @click.stop="operatorDelOrg(data)"
                    v-if="$permission('org:delete')"
                >
                  <i class="el-icon-delete"></i>
                </gj-button>
              </div>
<!--            </div>-->
          </div>
      </el-tree>
      <gj-modal
          :visible.sync="modalVisible.editOrg"
          :size="'normal'"
          :destroy-on-close="true"
          @cancel="cancel"
          @confirm="confirm"
          :confirm-loading="editOrgLoading"
          @close='closeDialog'
      >
        <template #header>
          {{modalItem.orgItem === null ? '添加' : '编辑'}}部门
        </template>
        <template #content>
          <el-form
              ref="orgForm"
              :model="form"
              label-width="160px">
            <el-form-item label="部门名称" prop="name" :rules="[
                  { required: true, message: '请输入部门名称', trigger: 'blur' },
                  { min: 1, max: 40, message: '限制1-40个字符', trigger: 'blur' },
              ]">
              <gj-input v-model="form.name" width="220px"></gj-input>
            </el-form-item>
            <el-form-item label="上级部门">
              <gj-tree-select
                  :data="editOrgData"
                  v-model="form.parentOrg"
                  width="220px"
              >
              </gj-tree-select>
            </el-form-item>
          </el-form>
        </template>
      </gj-modal>
    </div>
  </div>
</template>

<script>
  import {orgTree, addOrg, updaOrg, delOrg, getEditTree} from '../../../../../api/setting';
  import {isMeaningful} from "../../../../../utils/common";

  export default {
    name: "user-tree-list",
    watch: {
      filterText(val) {
        this.$refs.tree2.filter(val);
      }
    },
    data() {
      return {
        editOrgData: [],
        filterText: '',
        loading: false,
        editOrgLoading: false,
        parentValue: 1,
        data2: [],
        defaultProps: {
          children: 'children',
          label: 'label'
        },
        modalVisible: {
          editOrg: false,
          delOrg: false,
        },
        modalItem: {
          orgItem: null,
          delOrgRow: null,
        },
        form: {
          id: null,
          name: '',
          status: 0,
          parentOrg: null,
        },
        sign: '',
      };
    },
    created() {
      this.queryData();
    },
    methods: {
      filterNode(value, data) {
        if (!value) return true;
        return data.label.indexOf(value) !== -1;
      },
      openEditOrg(item) {
        if (item === null) {
          this.editOrgData = this._.cloneDeep(this.data2);
        } else {
          this.loadEditOrg(item.id);
        }
        this.modalVisible.editOrg = true;
        this.modalItem.orgItem = item;
        if (item != null) {
          this.form.parentOrg = (isMeaningful(item.parentId) && item.parentId !== '0') ? item.parentId : null;
          this.form.name = item.label;
        }
      },
      loadEditOrg(id) {
        getEditTree(id)
          .then((res) => {
            this.editOrgData = res.data || [];
          })
      },
      confirm() {
        this.$refs.orgForm.validate((valid) => {
          if (valid) {
            this.editOrgLoading = true;
            if (this.modalItem.orgItem == null) {
              const params = {
                label: this.form.name,
                parentId: this.form.parentOrg
              };
              addOrg(params).then(response => {
                if (response.isSuccess) {
                  this.$message.success("新增成功");
                  this.queryData();
                  this.modalItem.orgItem = null;
                  this.modalVisible.editOrg = false;
                  this.closeDialog();
                } else {
                  this.$message.success("操作失败");
                }
              }).complete(() => {
                this.editOrgLoading = false;
              })
            } else {
              const params = {
                id: this.modalItem.orgItem.id,
                label: this.form.name,
                parentId: this.form.parentOrg
              };
              updaOrg(params).then(response => {
                if (response.isSuccess) {
                  this.$message.success("修改成功");
                  this.queryData();
                  this.modalItem.orgItem = null;
                  this.modalVisible.editOrg = false;
                  this.closeDialog();
                } else {
                  this.$message.success("操作失败")
                }
              }).complete(() => {
                this.editOrgLoading = false;
              })
            }
          }
        });
      },
      cancel() {
        this.modalItem.orgItem = null;
        this.modalVisible.editOrg = false;
        this.closeDialog();
      },
      operatorDelOrg(row) {
        const vm = this;
        const modal = this.$gjCreate("gj-info-modal", {
          props: {
            title:'删除确认',
            content: `删除后不可恢复，确认要删除吗？`,
          },
          on: {
            cancel: () => modal.$gjDestroy(),
            confirm() {
              modal.confirmLoading = true;
              const params = [];
              params.push(row.id);
              delOrg(params).then(response => {
                if (response.isSuccess) {
                  vm.$message.success("操作成功");
                  modal.$gjDestroy();
                  vm.queryData();
                } else {
                  this.$message.success("操作失败")
                }
              }).complete(() => modal.confirmLoading = false)
            }
          },
        });
      },
      checkOrg(data) {
        this.sign = data;
        this.$emit('sendOgr', data)
      },
      closeDialog() {
        this.form = {
          id: null,
          name: '',
          status: 0,
          parentOrg: null,
        }
        this.modalItem.orgItem = null;
      },
      queryData() {
        this.loading = true;
        orgTree().then(response => {
          this.data2 = response.data;
          this.checkOrg(null);
        }).complete(() => this.loading = false)
      }
    },
  }
</script>

<style lang="scss" scoped>
.custom-tree-node{
  flex: 1;
  padding-right: 20px;
  .custom-tree-node-name{
    //white-space: nowrap;
    //text-overflow: ellipsis;
    //overflow: hidden;
    color: #333;
    font-size: 12px;
  }
  .gj-tree-child{
    position: relative;
    right: 0;
  }
}
  .tree-header {
    padding: 8px 12px;
    background: #ffffff;
    font-size: 14px;
    border-bottom: 1px solid #EBEEF5;
  }

  .tree-header-title {
    color: #333;
    font-weight: 700;
  }

  .tree-content {
    background: #ffffff;
    display: flex;
    flex-direction: column;
    height: 100%;
    /* box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.15); */
  }

  .tree-body {
    flex: 1;
    overflow: auto;
    &::-webkit-scrollbar-track{
      background: #fff;
    }
  }

  .filter-tree {
    height: 100%;
  }

  .top-input {
    padding: 12px;
    border-bottom: 1px solid #e8e8e8;
    display: flex;
    align-items: center;
    justify-content: space-between;
  }

  .add-styl {
    font-weight: bold;
    font-size: 20px;
    color: #999999;
  }

  .gj-tree-child {
    display: none;
    position: absolute;
    right: 5px;
  }

  /deep/ .el-tree--highlight-current .el-tree-node.is-current > .el-tree-node__content {
    /* color: #30adff; */
    /* border: 1px solid #30adff; */
    background: #EDF7FF;
  }
</style>
